module.exports = {"urls":["./build/sound_2.mp3"],"sprite":{"silence":[0,244323.26530612243],"alls":[246000,186279.18367346938]}}


//////////////////
// WEBPACK FOOTER
// ./src/components/sound/audio/sound_2.json
// module id = e8uc
// module chunks = 0